import { MapPinOff } from "lucide-react";
import { Link } from "react-router-dom";

export default function RegionBlocked() {
  return (
    <div className="min-h-screen flex items-center justify-center p-10 noise">
      <div data-testid="region-blocked" className="glass rounded-3xl p-12 max-w-lg flex flex-col gap-5 rise">
        <MapPinOff className="w-10 h-10 text-red-400" />
        <h1 className="text-2xl">Please turn off your VPN</h1>
        <p className="text-sm text-slate-300">Your connection looks like a VPN, a proxy or a data centre, so we can't open an account or sign you in through it. Your attempt has been noted for review.</p>
        <p className="text-sm text-slate-400">Turn the VPN or proxy off (or switch from a company network) and try again.</p>
        <Link to="/" data-testid="region-back" className="text-sm text-amber-300 hover:text-amber-200">← Back</Link>
      </div>
    </div>
  );
}
